export default __webpack_public_path__ + "static/media/bloggie.47e2bd35.png";